import React, { KeyboardEvent } from 'react';
import { Input } from '../../Input';
import { useKeyboardShortcut } from '../../../Lib/KeyboardShortcuts/hooks/useKeyboardShortcut';

function SearchBar({
	onSearchType,
	keyboardShortcut,
}: {
	onSearchType?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
	keyboardShortcut: boolean;
}) {
	const searchInputRef = React.useRef<HTMLInputElement | null>(null);
	const [value, setValue] = React.useState('');

	if (keyboardShortcut) {
		useKeyboardShortcut({
			id: 'HEADER_SEARCH',
			handler: () => {
				searchInputRef.current?.focus();
			},
		});
	}

	const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
		if (onSearchType) {
			onSearchType(event);
		}
	};

	// hint: https://www.w3.org/WAI/ARIA/apg/example-index/landmarks/search.html
	return (
		<form role="search" aria-label="global search">
			<Input
				clearable
				placeholder="Search"
				aria-label="search text"
				iconBefore="search"
				className="w-22-24 mr-m"
				onKeyDown={onKeyDown}
				ref={searchInputRef}
				value={value}
				onChange={event => setValue(event.target.value)}
			/>
		</form>
	);
}

export default SearchBar;
